import React, { Suspense, useCallback, useEffect, useState } from "react";
import { Row, Col, Modal, Form, message } from "antd";
import { Main } from "../styled";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAboutInformationData, getExchangeDetails, getPPTinformationDetailsReset, getPPTinformationListReset, postStartToken, submitPPTInfomation, submitPPTInfomationReset, } from "../../redux/about/actionCreator";
import { getExchangeModelDetail } from "../../redux/common/actionCreator";
import SearchList from "../../components/about/SearchList";
import ViewPPTList from "../../components/about/ViewPPTList";
import { v4 as uuidv4 } from "uuid";
import InitialScreen from "../../components/about/InitialScreen";
import PageLoader from "../../components/about/PageLoader";
import ProductDetails from "../../components/about/ProductDetails";
import OldPhoneSearchList from "../../components/about/OldPhoneSearchList";
import ExchangePrice from "../../components/about/ExchangePrice";
import Spinner from "../../components/utilities/Spinner";

const SearchProductPage = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({});
    const [startProcess, setStartProcess] = useState(false);
    const [loader, setLoader] = useState(false);
    const [, setAutoStop] = useState(false);
    const [, setAutoResume] = useState(false);
    const [form] = Form.useForm();
    const [modelSubmit, setModelSubmit] = useState(false);

    const [isModalVisible, setIsModalVisible] = useState(false);

    const aboutInfoDataDetails = useSelector((state) => state.aboutInfoData);
    const aboutInfoPPTListData = useSelector((state) => state.aboutInfoPPTListData);
    const aboutInfoPPTDetailsData = useSelector((state) => state.aboutInfoPPTDetailsData);
    const submitAboutPPTInfoDataDetails = useSelector((state) => state.submitAboutPPTInfoData);
    const aboutExchangeData = useSelector((state => state.getExchangeData)) || {};
    const exchangeModelDetail = useSelector((state => state.exchangeModelDetail))
    const postStartTokenData = useSelector((state) => state.postStartTokenData)
    console.log(postStartTokenData);

    const [isVisible, setIsVisible] = useState(true);
    const [tabPPTInfo, setTabPPTInfo] = useState([]);
    const [comparissionTableData, setComparissionTableData] = useState([]);
    const [activeTabId, setActiveTabId] = useState(null);
    const [selectedOldPhone, setSelectedOldPhone] = useState(null)
    const [exchangeCheckedDetails, setExchangeCheckedDetails] = useState([]);
    const [token, setToken] = useState(() => localStorage.getItem('sectionId'));

    const handleStartProcess = useCallback(() => {
        const sectionToken = uuidv4();
        localStorage.setItem("sectionId", sectionToken);
        setToken(sectionToken);
        setStartProcess(true);
        dispatch(postStartToken({ token: sectionToken, type: "start" }));
    }, [dispatch]);

    const deleteTabAtIndex = (indexToDelete) => {
        setTabPPTInfo((prevItems) => {
            const newItems = prevItems.filter((_, index) => index !== indexToDelete);
            if (newItems.length === 0) {
                setIsVisible(true);
            }
            return newItems;
        });
        setComparissionTableData((prevItems) =>
            prevItems.filter((_, index) => index !== indexToDelete)
        );
    };

    const handleOldPhone = (value) => {
        if (value) {
            console.log("id:", value);
            dispatch(getExchangeDetails({ id: value }))
            setSelectedOldPhone(value)
        } else {
            console.error("Please select a valid option", value);

        }
    }

    const buildFinalSubmitLog = useCallback((submitData) => {
        const openedDeviceDetails = tabPPTInfo.map((item) => {
            const details = item?.data || {};
            const offerDetails = details.offer_details || {};
            const { offer_details: offilineOffers = [] } = offerDetails;
            const onlineOffers = details.product_offers?.data || [];
            const modelId = offerDetails.model_id;
            const productSpecification = Array.isArray(details.product_specification?.data)
                ? details.product_specification.data.flatMap((item) => item?.product_specification || [])
                : details.product_specification?.product_specification || null;

            return {
                model_id: modelId,
                model_name: offerDetails.model_name,
                ppt_details: details.check_document || null,
                offer_details: {
                    online_offers: onlineOffers,
                    offiline_offers: offilineOffers,
                },
                product_specification: productSpecification,
                product_images: details.product_specification?.data[0]?.img_details || null,
            };
        });

        return {
            ...submitData,
            other_details: {
                devices_checked: openedDeviceDetails,
                exchange_details_checked: exchangeCheckedDetails,
            },
        };
    }, [exchangeCheckedDetails, tabPPTInfo]);

    useEffect(() => {
        const { data, error } = postStartTokenData
        if (error) {
            message.error(error)
        }

        if (data?.status) {
            localStorage.setItem("tango-token", data?.data)
        }

    }, [postStartTokenData])

    useEffect(() => {
        dispatch(getAboutInformationData());
        dispatch(getExchangeModelDetail())
    }, []);

    useEffect(() => {
        return () => {
            dispatch(getPPTinformationDetailsReset());
            dispatch(getPPTinformationListReset());
            dispatch(submitPPTInfomationReset());
            localStorage.removeItem("sectionId");
            localStorage.removeItem("tango-token");
            setToken(null)
        };
    }, []);

    useEffect(() => {
        console.log("Location changed:", location?.state);
        if (location?.state?.id && !startProcess) {
            handleStartProcess();
        }
    }, [location, startProcess, handleStartProcess]);

    useEffect(() => {
        if (!aboutInfoPPTDetailsData) return;

        if (aboutInfoPPTDetailsData.data?.check_document) {
            setTabPPTInfo((prevItems) => {
                // const updatedData = [...prevItems];
                // const alreadyExists = updatedData.some(
                //   (entry) =>
                //     entry.data?.check_document?.id ==
                //     aboutInfoPPTDetailsData?.data?.check_document?.id
                // );
                // if (alreadyExists) {
                //   setActiveTabId(aboutInfoPPTDetailsData?.data?.check_document?.id);
                // } else {
                //   updatedData.push(aboutInfoPPTDetailsData);
                // }
                // // return updatedData;
                // return updatedData;
                return [...prevItems, aboutInfoPPTDetailsData];
            });
        }

        const productSpec = aboutInfoPPTDetailsData.data?.product_specification;
        if (productSpec?.http_code === 200) {
            const specData = productSpec.data;

            setComparissionTableData((prev) => {
                const updatedData = [...prev];

                specData.forEach((item) => {
                    if (!item?.product_id) return;

                    const alreadyExists = updatedData.some(
                        (entry) => entry.productId === item.product_id
                    );

                    if (!alreadyExists) {
                        updatedData.push({
                            productId: item.product_id,
                            productName: item.product_group_name,
                            tableData: item.product_specification,
                        });
                    }
                });

                return updatedData;
            });
        }
        if (productSpec?.http_code === 400) {
            setIsModalVisible(true);
        }
    }, [aboutInfoPPTDetailsData]);

    useEffect(() => {
        if (
            submitAboutPPTInfoDataDetails?.data === "submitted" &&
            submitAboutPPTInfoDataDetails?.loading === false
        ) {
            Modal.info({
                title: "Submitted Successfully",
                okText: "Ok",
                onOk() {
                    dispatch(submitPPTInfomationReset());
                    dispatch(getPPTinformationDetailsReset());
                    dispatch(getPPTinformationListReset());
                    setStartProcess(false);
                    setIsVisible(true);
                    setTabPPTInfo([]);
                    localStorage.removeItem("sectionId");
                    localStorage.removeItem("tango-token");
                    form.resetFields();
                    setLoader(false);
                    setFormData({});
                },
            });
        }

        if (
            submitAboutPPTInfoDataDetails?.error &&
            submitAboutPPTInfoDataDetails?.loading === false
        ) {
            Modal.error({
                title: "Please try Again",
                okText: "Ok",
                footer: null, // Disable the default footer
                onOk() {
                    dispatch(submitPPTInfomationReset());
                    dispatch(getPPTinformationDetailsReset());
                    dispatch(getPPTinformationListReset());
                    localStorage.removeItem("sectionId");
                    localStorage.removeItem("tango-token");
                    form.resetFields();
                    setLoader(false);
                    setFormData({});
                },
            });
        }
    }, [submitAboutPPTInfoDataDetails, dispatch]);

    useEffect(() => {
        if (aboutExchangeData?.data?.status) {
            console.log("aboutExchangeData:", aboutExchangeData?.data?.data);
            if (selectedOldPhone) {
                setExchangeCheckedDetails(prevState => {
                    const exchangeModel = exchangeModelDetail?.data?.find(
                        (model) => String(model.id) === String(selectedOldPhone)
                    );
                    const nextDetails = {
                        old_model_id: selectedOldPhone,
                        old_model_name: exchangeModel?.model_name,
                        exchange_details: aboutExchangeData?.data?.data,
                    };
                    const filteredDetails = prevState.filter(
                        (item) => String(item.old_model_id) !== String(selectedOldPhone)
                    );
                    return [...filteredDetails, nextDetails];
                });
                setFormData(prevState => {
                    const oldmodelIds = prevState.old_model_viewed || [];
                    const oldmodelUniqueIds = new Set([...oldmodelIds, selectedOldPhone]);
                    return {
                        ...prevState,
                        old_model_viewed: Array.from(oldmodelUniqueIds),
                    };
                });
            }
        }
    }, [aboutExchangeData, selectedOldPhone, exchangeModelDetail?.data])


    useEffect(() => {
        if (location?.state?.oldValue) {
            handleOldPhone(location?.state?.oldValue)
        }
    }, [location?.state?.oldValue]);

    useEffect(() => {
        if (modelSubmit) {
            const submitPayload = buildFinalSubmitLog(formData);
            dispatch(submitPPTInfomation(submitPayload))
            setModelSubmit(false);
            setLoader(true);
        }
    }, [formData, modelSubmit, dispatch, buildFinalSubmitLog]);

    // useEffect(() => console.log("formData", formData), [formData])
    return (
        <>
            {/* <CustomHeader>
                <Breadcrumb
                    separator=" :: "
                    items={[
                        {
                            title: (
                                <span
                                    style={{ cursor: "pointer", color: "#1677ff" }}
                                    onClick={() => navigate(-1)}
                                >
                                    Dashboard
                                </span>
                            ),
                        },
                        {
                            title: "Search Product",
                        },
                    ]}
                />
            </CustomHeader> */}

            <Main>
                <Suspense fallback={<Spinner />}>
                    {!startProcess && (
                        <InitialScreen onStart={handleStartProcess} />
                    )}

                    {loader && <PageLoader />}

                    {startProcess && !loader && (
                        <>
                            <Row gutter={[16, 16]}>
                                {aboutInfoDataDetails?.data?.model_list && aboutInfoDataDetails?.data?.model_list.length > 0 && (
                                    <Col xxl={24} lg={24} md={24} xs={24}>
                                        <Row gutter={16} justify={"center"}>
                                            <Col xs={24} md={(selectedOldPhone && !isVisible) ? 24 : 12} lg={(selectedOldPhone && !isVisible) ? 14 : 12} style={{ marginBlock: "10px" }}>
                                                {selectedOldPhone && !isVisible ?
                                                    <ExchangePrice
                                                        selectedOldPhone={selectedOldPhone}
                                                        setSelectedOldPhone={setSelectedOldPhone}
                                                        data={aboutExchangeData?.data?.data}
                                                        exchangeModels={exchangeModelDetail.data}
                                                    />
                                                    :
                                                    <OldPhoneSearchList
                                                        data={exchangeModelDetail.data}
                                                        handleOldPhone={handleOldPhone}
                                                    />
                                                }
                                            </Col>
                                            {isVisible ? (
                                                <Col xs={24} md={12} lg={12} style={{ marginBlock: "10px" }}>
                                                    <SearchList
                                                        data={aboutInfoDataDetails?.data?.model_list}
                                                        setIsVisible={setIsVisible}
                                                    />
                                                </Col>
                                            )
                                                :
                                                <Col xs={24} md={10} style={{ marginBlock: "10px" }}>
                                                    <ViewPPTList
                                                        data={aboutInfoPPTListData?.data?.document}
                                                        model_id={aboutInfoPPTListData?.data?.model_details}
                                                        formData={formData}
                                                        setFormData={setFormData}
                                                    />
                                                </Col>
                                            }
                                        </Row>
                                        {/* <SearchList data={aboutInfoDataDetails?.data?.model_list} /> */}
                                    </Col>
                                )}
                            </Row>

                            <Row gutter={25} style={{ marginBottom: "20px" }}>
                                {tabPPTInfo.length > 0 ? (
                                    <Col xxl={24} lg={24} md={24} xs={24}>
                                        {/* <ViewPPTDetails data={aboutInfoPPTDetailsData.data.check_document} /> */}
                                        <ProductDetails
                                            data={tabPPTInfo}
                                            searchList={aboutInfoDataDetails?.data?.model_list}
                                            deleteTabAtIndex={deleteTabAtIndex}
                                            activeTabId={activeTabId}
                                            selectedOldPhone={selectedOldPhone}
                                            isVisible={isVisible}
                                            comparissionTableData={comparissionTableData}
                                            setAutoStop={setAutoStop}
                                            formData={formData}
                                            setFormData={setFormData}
                                            form={form}
                                            setLoader={setLoader}
                                            setAutoResume={setAutoResume}
                                            modelSubmit={modelSubmit}
                                            setModelSubmit={setModelSubmit}
                                        />
                                    </Col>
                                ) : (
                                    <Col xxl={16} lg={16} md={24} xs={24}></Col>
                                )}

                                <Col xxl={8} lg={8} md={24} xs={24}>
                                    {/* {aboutInfoPPTDetailsData.data.offer_details && (
                                        <OfferDetails data={aboutInfoPPTDetailsData.data.offer_details} />
                                    )} */}
                                    {/* {aboutInfoPPTDetailsData?.data?.check_document &&
                                        <ViewPPTDetails data={aboutInfoPPTDetailsData?.data?.check_document} />
                                    }
                                    <HandwritingNotes
                                        setAutoStop={setAutoStop}
                                        formData={formData}
                                        setFormData={setFormData}
                                        form={form}
                                        setLoader={setLoader}
                                        setAutoResume={setAutoResume}
                                    /> */}
                                </Col>

                                {/* <Col xxl={8} lg={0} md={0} xs={24}>
                                    <WriteNotes form={form} />
                                </Col> */}
                                {/* {aboutInfoPPTDetailsData?.data?.product_specification &&
                                    comparissionTableData.length > 0 && (
                                        <Col xxl={24} lg={24} md={24} xs={24}>
                                            <TableWrapper className="table-responsive">
                                                <ComparisonTable data={comparissionTableData} />
                                            </TableWrapper>
                                        </Col>
                                    )} */}
                            </Row>
                        </>
                    )}
                    <Modal
                        title="Invalid Product"
                        open={isModalVisible}
                        onOk={() => setIsModalVisible(false)}
                        onCancel={() => setIsModalVisible(false)}
                        okText="OK"
                        cancelButtonProps={{ style: { display: "none" } }}
                    >
                        <p>Comparission Data is not available for this product</p>
                    </Modal>
                </Suspense>
            </Main>
        </>
    );
};

export default SearchProductPage;
